export const Bio = {
  name: "Anshul Bhathija",
  roles: [
    "Full Stack Developer",
    "App Developer",
    "Programmer",
    "ML Developer",
    
  ],
  description:
    "I’m a full-stack and app developer who enjoys building things that work beautifully and scale effortlessly. From pixels to APIs, I love owning the entire development process. With a strong learning mindset and obsession with quality, I’m constantly pushing myself to create smarter, cleaner, and more impactful solutions.",
  github: "https://github.com/codecrafter071727",
  resume:
    "https://drive.google.com/file/d/10Ah_HcUi5v1sPwVq-IyQBzS59SJVY5G5/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/anshul-bhathija-8229b0301/",
  twitter: "",
  insta: "https://www.instagram.com/anshul._.x07?igsh=MWc3c28ydmhyeno4Yw==",
  facebook: "",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },

      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "Redux",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
      },
      {
        name: "Zustand",
        image: "https://logo.svgcdn.com/devicon/zustand-original.svg",
      },
      {
        name: "Zod",
        image: "https://raw.githubusercontent.com/colinhacks/zod/master/logo.svg",
      },
      {
        name: "React Context",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "typescript",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
      },
      
      
      
      {
        name: "SEO Optimization",
        image: "https://cdn-icons-png.flaticon.com/512/2721/2721291.png",
      },
      
      
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },

      {
        name: "Django",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlFFyY16N5NRhzoG24RqB7x8Ok2t8Bdgs-tuMsOBXS2Q&s",
      },

      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "FastAPI",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/fastapi/fastapi-original.svg",
      },
      {
        name: "PostgreSQL",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original.svg",
      },
      {
        name: "Prisma",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/prisma/prisma-original.svg",
      },
      {
        name: "Redis",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redis/redis-original.svg",
      },
      {
        name: "Docker",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original.svg",
      },
      {
        name: "WebSocket",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/socketio/socketio-original.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      
      
      
      {
        name: "Postman",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/postman/postman-original.svg",
      },
      
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
      {
        name: "Cloudinary ",
        image:
          "https://res.cloudinary.com/cloudinary/image/upload/new_cloudinary_logo_square.png",
      },
      {
        name: "Razorpay",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTnA99TABOEvVDdjInRpcHjvKZIhgCnv0z9zg&s",
      },
      {
        name: "Stripe",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRGSJGUqaaCZjtvdlOe217llBsDbQN8ZN8l8w&s",
      },
    ],
  },

  
  {
    title: "Languages",
    skills: [
      {
        name: "python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "C++",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
      },
      {
        name: "TypeScript",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
      },
      {
        name: "go",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/go/go-original.svg",
      }
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://sapphire-landing-three.vercel.app/logo.svg",
    role: "Full Stack Developer",
    company: "Sapphire Broking",
    date: "August 2025 - November 2025",
    desc: "• Frontend development for live trading and market-data platforms.\n• BSE & NSE API integration using Golang and Node.js.\n• Low-latency backend services for real-time stock market data.\n• Secure, scalable REST APIs designed for financial systems.",
    
    doc: [
      "https://res.cloudinary.com/dejquvzim/image/upload/v1769872320/sapphire1_c0ueui.png",
      "https://res.cloudinary.com/dejquvzim/image/upload/v1769872811/sapphire_2_zkxhbt.png",
    ],
  },
  {
    id: 1,
    img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAcCAMAAACnDzTfAAAAb1BMVEXEtobHuIjHuInTwYnXxYvXxIzWxIvWxIzXxYzbyY6GfVzezI/NvYd3blAAAACqnnM1MijfzZHIuIRlYEhdVkANEhIAAAs+OiysoHKIfl9RTTonJSMABglGQjmgk2qSh2MAAAO7rHzq1pYeHhwvLyVM11PtAAAA6ElEQVR4AXTSBRaDMBAAUSwOi7vL/c/YTS1JZXD+w/E83w/87/Q+L4z+5oWEvmM4WBto7F9of3sfRwgXgnAdMcdRHYlEKKXAPWHI6SNtWlScAEAKWJYz23hR4s4q5VDXTasci7p+GLoEinKsp0wR29S8yBXKWC1bDat4X09fWQxrma4pWwApp46xWIa5bEEfpYhrlAvOVLdN5ihjeKhIoQZpyDLRweQSGnkctSMl+WPDNY60JUeuE4i2CQnTNJ5nPW3Q5l+2bXAPjX7au8syHS92U2S+7QN1URRxHKmxP//SbTD7EIDWcgDp6xnftiQ0TQAAAABJRU5ErkJggg==",
    role: "Full Stack developer",
    company: "Zarva-RedifinedTravelSafety",
    date: "January 2025 - October 2025",
    desc: "• Designed and developed the complete full-stack architecture (frontend + backend) for Zarva – Redefined Travel Safety, ensuring scalability, performance, and secure data handling.\n• Built an AI-driven “Safer Location” system that evaluates and ranks areas using real-time location data, crime rates, population density, and contextual safety metrics.\n• Implemented a speech recognition–based emergency trigger, where predefined keywords activate automated safety workflows in critical situations.\n• Engineered an automated alert & calling system that instantly shares the user’s live location with trusted contacts after repeated voice-trigger activation.",
    
    doc: [
      "https://res.cloudinary.com/dejquvzim/image/upload/v1769943887/zarva1_fpctlb.png",
      "https://res.cloudinary.com/dejquvzim/image/upload/v1769943886/zarva2_afn1vq.png",
    ],
  },
  {
    id: 2,
    img: "https://dogowala.in/wp-content/uploads/2024/09/6c665498-60c4-4f6a-aac8-0fd96a1a7d76.webp",
    role: "wordpress developer",
    company: "Dogowala",
    date: "June 2025 - August 2025",
    desc: "• Shipped and customized a production WordPress website.\n• Debugged and stabilized the payment gateway flow.\n• Resolved critical bugs impacting user conversions.\n• Improved site performance, reliability, and UX.",
    doc: [
      "https://res.cloudinary.com/dejquvzim/image/upload/v1769943886/dogo1_xt4hdz.png",
      "https://res.cloudinary.com/dejquvzim/image/upload/v1769943886/dogo2_b78shl.png",
    ],
  },
  {
    id: 3,
    img: "https://www.seneracore.com/logo.svg",
    role: "Full-stack Developer",
    company: "Seneracore",
    date: "Novemeber 2025 - December 2025",
    desc: "• Built and maintained the frontend of Seneracore.\n• Developed a responsive, high-performance UI.\n• Integrated frontend with backend APIs.\n• Improved UX, speed, and scalability.",
    doc: [
      "https://res.cloudinary.com/dejquvzim/image/upload/v1769943886/senerecore_oxsjxl.png",
      "https://res.cloudinary.com/dejquvzim/image/upload/v1769943886/senerecore2_fwynij.png",
    ],
  },
  
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS5Uv9hr5ERN8A3RX2LwD_KqK3kC63awE-RTg&s",
    school: "Bennett University(THE TIMES NOW)",
    date: "AUG 2024 - MAY 2028",
    grade: "9.13 SGPA",
    desc: "• AI-specialized Full-Stack Developer focused on building intelligent, scalable products.\n• Tech Head – CSI (Computer Society of India), driving technical strategy and execution.\n• Active member of Ciphers BU, International Affairs Society, E-Cell, and Enactus, collaborating across tech, innovation, and entrepreneurship.\n• Strong in leadership, problem-solving, and cross-team collaboration through real-world projects.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQHC2qw_DP3Dvr_il0LQL5YbgeYiYwIgXZLQ&s",
    school: "Bhartiyam Vidya Niketan",
    date: "Apr 2022 - Apr 2024",
    grade: "82.5%",
    desc: "I completed my class 12 high school education at bhartiyam vidya niketan , Gwalior, where I studied Science .",
    degree: "CBSE(XII), Science",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR53xhKeTHXg3v3ouN5vl0xt-FTEwxVz6yF7A&s",
    school: "Miss Hill Higher Secondary School , Gwalior",
    date: "Apr 2016 - Apr 2022",
    grade: "91.5%",
    desc: "I completed my class 10 education at Miss Hill Higher Secondary School, Gwalior , where I studied Science with Computer Application.",
    degree: "CBSE(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 11,
    title: "PRISCRIPTO",
    date: "Dec 2024 - Jan 2025",
    description:
      "Prescripto – Simplifying healthcare, empowering lives. We are dedicated to connecting patients and healthcare providers through innovation and technology, ensuring convenient access to care and seamless management of health records. Trust us to support you at every step of your healthcare journey Prescripto – Simplifying healthcare, empowering lives. We are dedicated to connecting patients and healthcare providers through innovation and technology, ensuring convenient access to care and seamless management of health records. Trust us to support you at every step of your healthcare journey",
    image:
      "/Screenshot 2025-02-21 202709.png",
    tags: [
      "React Js",
      "Java script",
      "Node Js",
      "Express Js",
      "Mongo DB",
      "Cloudinary",
      "Payemnet Gateway System",
    ],
    category: "web app",
    github: "https://github.com/codecrafter071727/prescripto-full-stack",
    webapp: "https://prescripto-full-stack-frontend2.onrender.com/",
  },
  
  {
    id: 13,
    title: "FIFA-AUCTION",
    date: "Feb 2025 - Feb 2025",
    description:
      "I built a FIFA Auction Website that allows users to enter the name of any footballer and instantly retrieve detailed information, including their height, scores, career stats, and other key attributes. This platform provides an intuitive and interactive experience for football enthusiasts, making it easier to explore player data efficiently. Using a seamless combination of frontend and backend technologies, the website ensures real-time data fetching and a smooth user interface, making it a valuable tool for both casual fans and serious analysts. ",
    image:
      "/fifa.png",
    tags: [
      "React Js",
      "Java script",
      "Tailwind",
      "Shad-Cn",
      
      
    ],
    category: "web app",
    github: "https://github.com/codecrafter071727/FIFA-Auction",
    webapp: "https://fifa-auction.vercel.app/",
  },
  {
    id: 14,
    title: "CITYCARE",
    date: "Sep 2024 - Oct 2024",
    description:
      "Created 'City Care,' a healthcare platform designed to connect patients with hospitals and doctors. The platform features real-time hospital bed availability, allowing patients to quickly find care, and an intuitive Symptom Checker to assist in diagnosing symptoms and suggesting specialists. This project focuses on improving patient access to timely and accurate healthcare information ",
    image:
      "/Citycare.png",
    tags: [
      "React Js",
      "Java script",
      "Node Js",
      "Express Js",
      "Mongo DB",
      "Cloudinary",
      "Payemnet Gateway System",
      
      
      
    ],
    category: "web app",
    github: "https://github.com/codecrafter071727/CityCare",
    webapp: "https://city-care.vercel.app/",
  },
  
  
  {
    id: 17,
    title: "VISION-CLONE",
    date: "NOV 2024 - DEC 2024",
    description:
      "I built a Vision Clone using HTML, CSS, JavaScript, and GSAP to replicate a smooth and dynamic user experience. This project features a modern UI with seamless animations powered by GSAP (GreenSock Animation Platform), ensuring fluid transitions and engaging interactions. The design is fully responsive, adapting to different screen sizes while maintaining a visually appealing layout. Key highlights include interactive elements, scroll-based animations, and smooth page transitions, making the clone both aesthetically pleasing and highly functional. This project showcases my skills in frontend development, animation, and user interface design. ",
    image:
      "/Visionclone.png",
    tags: [
      "HTML",
      "CSS",
      "Javascript",
      "GSAP",
      
      
      
    ],
    category: "web app",
    github: "https://github.com/codecrafter071727/vision-clone-",
    webapp: "https://vision-clone.onrender.com",
  },
  {
    id: 18,
    title: "NETFLIX",
    date: "Aug 2024 - Aug 2024",
    description:
      "Developed a Netflix clone with HTML and CSS, focusing on the design and feel of the original site. Made it responsive to work on all devices. This project showcases my skills in creating attractive and functional web layouts ",
    image:
      "/Netflix.png",
    tags: [
      "HTML",
      "CSS",
      "Javascript"
      
      
      
    ],
    category: "web app",
    github: "https://github.com/codecrafter071727/NETFLIX",
    webapp: "/",
  },
];

